import React from "react";

import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

const WelcomeMessage = () => {
  const { t } = useTranslation("component");
  return (
    <Typography variant="h6" color="white">
      {t("welcomeMessage.message")}
    </Typography>
  );
};

export default WelcomeMessage;
